var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNextArrow = function SvgNextArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.667,
    height: 20.611,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m2.048.686 8.901 8.902c.39.39.39 1.044 0 1.435l-8.901 8.902c-.376.375-.971.402-1.347.026l-.04-.041c-.377-.376-.359-.962.017-1.338l8.266-8.266L.678 2.039A.966.966 0 0 1 .686.675a.973.973 0 0 1 1.362.011"
  })));
};
export default SvgNextArrow;